import { createAuthenticateUserValidator } from "#validators/auth.validator.factory";
// Use factory function with pass-through translation for type inference
const authenticateUserValidatorForType = createAuthenticateUserValidator((key) => key);
